<!--
 * @Author: 王云飞
 * @Date: 2022-01-13 09:08:05
 * @LastEditTime: 2022-01-21 13:35:53
 * @LastEditors: 王云飞
 * @Description: 
 * 
-->
<template>
  <div class="user-doc" id="userProtocol">
    <p>&nbsp;</p>
    <p>
      <strong>【审慎阅读】</strong>您在申请注册流程中点击同意前，应当认真阅读以下协议。
      <strong>
        <u>请您务必审慎阅读、充分理解协议中相关条款内容，其中包括但不限于：</u>
      </strong>
    </p>
    <p>
      <strong>
        <u>1</u>
      </strong>
      <strong>
        <u>、与您约定免除或限制责任的条款；</u>
      </strong>
    </p>
    <p>
      <strong>
        <u>2</u>
      </strong>
      <strong>
        <u>、与您约定的个人信息收集和使用、隐私政策的条款；</u>
      </strong>
    </p>
    <p>
      <strong>
        <u>3</u>
      </strong>
      <strong>
        <u>、与您约定的数字证书的申请和使用的条款；</u>
      </strong>
    </p>
    <p>
      <strong>
        <u>4</u>
      </strong>
      <strong>
        <u>、其他以粗体标识的重要条款内容</u>
      </strong>。
    </p>
    <p>
      当您按照注册页面提示填写信息、阅读并同意协议且完成全部注册程序后，即表示您已充分阅读、理解并接受协议的全部内容。
      <strong>
        <u>阅读协议的过程中，如果您不同意相关协议或其中任何条款约定，您应立即停止注册程序。</u>
      </strong>如您对协议有任何疑问，可向平台客服咨询。
    </p>
    <p>
      <strong>
        <u>&nbsp;</u>
      </strong>
    </p>
    <p>
      <strong>【特别提示】</strong>
      <u>根据我国《电子签名法》规定，本平台涉及的签署服务不适用于涉及以下内容的数据电文或电子缔约文件：</u>
    </p>
    <p>
      <strong>
        <u>1)</u>
      </strong>
      <strong>
        <u>涉及婚姻、收养、继承等人身关系的；</u>
      </strong>
    </p>
    <p>
      <strong>
        <u>2)</u>
      </strong>
      <strong>
        <u>涉及土地、房屋等不动产权益转让的；</u>
      </strong>
    </p>
    <p>
      <strong>
        <u>3)</u>
      </strong>
      <strong>
        <u>涉及停止供水、供热、供气、供电等公用事业服务的；</u>
      </strong>
    </p>
    <p>
      <strong>
        <u>4)</u>
      </strong>
      <strong>
        <u>法律、行政法规规定的不适用电子文书的其他情形。</u>
      </strong>
    </p>
    <p>
      <strong>
        <u>请勿通过本服务签署包含以上内容的协议，大众签章不因您签署涉及上述内容的数据电文或电子缔约文件而导致的效力瑕疵而承担任何责任。</u>
      </strong>
    </p>
    <p>
      <strong>
        <u>&nbsp;</u>
      </strong>
    </p>
    <p>
      <strong>大众签章平台用户注册与使用协议</strong>
    </p>
    <p>欢迎您使用大众签章平台的服务！</p>
    <p>
      本协议是由山东国盾网信息科技有限公司与大众签章平台注册用户签署的协议，具有合同效力。大众签章平台（以下简称&ldquo;大众签章&rdquo;）是由山东国盾网信息科技有限公司（以下简称本公司）运营及维护，向所有注册并通过大众签章实名认证的用户（下称&ldquo;用户&rdquo;或&ldquo;您&rdquo;）提供网上电子合同签署及存储等服务的平台。本协议更新日期为
      <u>2020年5月10日</u>。
    </p>
    <p>&nbsp;</p>
    <ul>
      <li>
        声明与承诺
        <ul>
          <li>您确认，在您注册成为大众签章用户使用本服务之前充分阅读、理解并接受大众签章平台用户注册与使用协议（以下简称&ldquo;本协议&rdquo;）所有条款。特别是与您的权益有或可能具有重大关系的条款，及对本公司具有或可能具有免责或限制责任的条款等。上述条款可能以加粗、加下划线等形式予以标注，请您注意查看。一旦您完成注册并使用本服务，即表示您对本协议的全部内容已充分阅读并认可和同意遵守本协议所有约定；若您不接受本协议的任意内容或无法准确理解其中任何条款约定，请立即停止注册，不要进行后续操作。</li>
          <li>您同意，本公司有权根据对本协议内容进行单方面的变更、修改等，并在大众签章平台上进行公告。您可以随时登陆大众签章平台查阅相关信息，无需另行单独通知您。变更后的协议和规范、规则一经公告，立即自动生效，对新协议、规则生效之后注册的用户发生法律效力。如您在新规则生效后继续使用大众签章服务的，即视为您已充分阅读、理解并接受经修订的协议和规则。如果您不同意相关变更，您应停止使用本服务。</li>
          <li>
            <strong>
              <u>您接受，本公司是第三方电子缔约服务提供商，并不介入任何您和您的缔约对象之间的业务行为。本公司不能控制缔约对象履行其在数据电文或电子缔约文件下的各项义务的能力。本公司不能也不会控制缔约各方履行协议义务。本公司对您与您的缔约对象之间就缔约的内容和缔约执行情况等产生的任何纠纷不承担任何法律责任或者连带法律责任。</u>
            </strong>
          </li>
          <li>
            您承诺
            <ul>
              <li>遵守中国法律、法规、规章及其他政府规范性文件的规定，如有违反而造成任何法律后果，您将以本人名义独立承担所有相应的法律责任。</li>
              <li>您是具有法律规定的完全民事权利能力和民事行为能力，能够独立承担民事责任的自然人（中华人民共和国境内（香港、澳门除外）的用户应年满18周岁），或者是在中国大陆地区合法开展经营活动或其他业务的法人或其他组织；本协议内容不受您所属国家或地区法律的排斥。不具备前述条件的，您应立即终止注册或停止使用本服务。您在使用本服务时，应自行判断对方是否是完全民事行为能力人并自行决定是否与对方进行数据电文或电子缔约文件的签署，且您应自行承担与此相关的所有风险，本平台不承担因对方身份确认失误而造成的损失。</li>
              <li>
                您在大众签章平台上的所有操作（包括但不限于缔约、存证）都是您个人意愿的表示，
                <strong>
                  <u>认可您在大众签章平台上签订的电子合同（或协议）和纸质合同（或协议）具备相同的效力，认可您在大众签章平台上的电子签名和您的手写签名具备相同的效力</u>
                </strong>。
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    <p>&nbsp;</p>
    <ul>
      <li>
        定义及解释
        <ul>
          <li>大众签章账户（或&ldquo;该账户&rdquo;）：是指您通过注册获得大众签章账号以供您使用大众签章提供的合同签署、存储等服务的账户。您可自行为该账户设置密码。您需使用本公司允许的方式，企业账户及个人账户均用手机号码登录等，作为登录大众签章的方式。本平台：除本协议另有规定外，指oaexpert.com及相关PC端与移动客户端即在其他应用下的小程序。</li>
          <li>CA机构：指获得《电子认证服务许可证》的第三方数字证书签发机构。</li>
          <li>电子签名认证证书（数字证书）：由第三方CA签发的，含有签发电子签名认证证书的电子认证服务机构名称、证书持有人名称、证书序列号、证书有效期、证书持有人的电子签名验证数据、电子认证服务机构的电子签名、工业和信息化部规定的其他内容的身份证明数据。请注意，该证书的有效期为1年，自签发之日起计算，大众签章保证您在使用我们的电子合同签约服务时，您的数字证书处于有效期内。</li>
          <li>电子签名：数据电文中以电子形式所含、所附用于识别签名人身份并表明签名人认可其中内容的数据。</li>
          <li>时间戳：指由第三方提供的具有法律效力的时间戳，证明某份电子数据在某个时间点已经存在，该时间点后的任何修改均能被发现。</li>
        </ul>
      </li>
      <li>服务内容</li>
    </ul>
    <p>大众签章服务，是指大众签章平台对平台注册认证用户提供的在线合同签署、存储、合同模板、存证出证、司法鉴定等服务，及您实际使用的本公司或本公司接受您的委托为您提供的其他服务，包括（但不限于）以下服务：</p>
    <ul>
      <li>电子合同签约服务</li>
    </ul>
    <p>通过&ldquo;大众签章&rdquo;平台，本公司向注册用户提供在该平台上的电子协议发送，签署，接受，打印等服务。</p>
    <ul>
      <li>合同存储、证据保全</li>
    </ul>
    <p>本公司通过指定合作方公司提供所有在&ldquo;大众签章&rdquo;平台上的电子交易证据保存服务，用户签署的文件在完成后，将由大众签章对签署完成的文件本身以及签署的流程信息等内容进行保存。合同的发起方及签署方可在本网站随时下载签署完成的合同。</p>
    <ul>
      <li>合同模板服务</li>
    </ul>
    <p>大众签章公开或共享了部分类型的合同、法律文书范本等以供您在签署相关合同时进行参考、修订。</p>
    <ul>
      <li>存证、出证服务</li>
    </ul>
    <p>大众签章作为独立的第三方电子合同平台，可为您出具电子版或纸质版本的证据报告，包括合同原文件数据、合同签署方账户信息和签署流程等信息，以证明电子文件以及签署过程的真实性。</p>
    <p>&nbsp;</p>
    <ul>
      <li>
        服务费用
        <ul>
          <li>
            在您使用大众签章服务时，本公司有权向您收取相应服务费用。具体服务类型和价格详见网站上公布的业务定价及有关规则或以您与本公司另行达成的其他书面协议为准。
            <strong>
              <u>本公司拥有制订及调整服务费标准之权利，费用标准一旦被修改，即公布在本网站上，修改后的费用标准一经公布即生效，适用于费用标准修改后发生的交易。</u>
            </strong>
          </li>
          <li>除非另有说明或约定，您同意本公司有权自您委托本公司代收或代付的账户余额或者其他资产中直接扣除上述服务费用。</li>
        </ul>
      </li>
    </ul>
    <p>您认可您的账户在大众签章中的消费记录、充值记录均以大众签章平台记录的数据为准。如您对该等数据存有异议的，应自您账户数据发生变动之日起三日内向本公司提出异议，并提供相关证据供本公司核实。您若在服务期满前请求终止服务，服务费用不予退还。</p>
    <ul>
      <li>大众签章在避免用户损失的前提下，有权单方决定暂时或永久地改变或停止提供某些服务。</li>
    </ul>
    <p>&nbsp;</p>
    <ul>
      <li>大众签章账户</li>
    </ul>
    <p>您所申请的大众签章账户是您依照本协议的约定注册并由本公司提供给您本人的账户。您应当依照本公司规定的程序规范进行使用。</p>
    <p>用户注册与实名认证</p>
    <ul>
      <li>
        用户注册与实名认证
        <ul>
          <li>大众签章户分为个人用户和企业用户，在您同意接受本协议并注册成为大众签章用户时，您已经年满18周岁，或者您是在中国大陆地区合法开展经营活动或其他业务的法人或其他组织；本协议内容不受您所属国家或地区法律的排斥。不具备前述条件的，您应立即终止注册或停止使用本服务。</li>
          <li>大众签章账户是本平台向您提供的唯一编号，除本协议另有规定或相关产品另有规则外，您须在本网站注册取得本公司提供给您的大众签章账户，并且按照本公司要求提供相关信息方可使用本公司提供的部分或全部服务。</li>
          <li>
            <strong>
              <u>您在注册时必须填写真实有效的企业信息或个人信息，确保注册时所需信息填写准确、完全。使用虚假信息注册的，会导致无法进行身份认证，进而影响到平台服务的使用。</u>
            </strong>大众签章有权审核、核对您的认证信息，未通过实名验证的用户，大众签章有权拒绝提供相应服务。但大众签章不对用户提供的信息的准确、有效和完整做出保证，用户对提交的信息自行负责。
          </li>
          <li>如果发现、怀疑您登记的信息错误（包括有意或无意行为）、不实、过期或不完整的，大众签章有权要求您限期作出说明、提供相关证明材料更正登记的信息，有权暂停或终止向您提供部分或全部服务。大众签章对此不承担任何责任，您将承担因此产生的任何直接或间接支出。</li>
          <li>
            您应当准确提供并及时更新您的资料（包括但不限于身份证、户口本、护照等证件或其他身份证明文件、联系方式、作为大众签章账户登录名的邮箱或手机号码、与大众签章账户绑定的邮箱、手机号码等），以便本公司与您进行及时、有效的联系。您应完全独自承担因通过这些联系方式无法与您取得联系而导致的您在使用本服务过程中遭受的任何损失或增加任何费用等不利后果。
            <strong>
              <u>您理解并同意，您有义务保持您提供的联系方式的有效性，如有变更需要更新的，您应按本公司的要求进行操作。因您未及时更新资料导致的一切后果，均应由您自行承担，该后果包括但不限于导致服务部分或全部终止或提供时发生任何错误、账户及电子签名制作数据被别人盗用。</u>
            </strong>
          </li>
          <li>
            您同意并授权大众签章审核、核对用户资料信息以确认您的身份。
            <strong>
              <u>您所提交的用户认证信息将用于核发其专属的电子签名文件，大众签章将对您的信息严格保密。隐私保护请详见《隐私声明》</u>
            </strong>。
          </li>
          <li>您设置的用户名不应包含有非法的内容或其他可能侵犯他人合法权益、违背社会公序良俗的内容。一经发现，平台有权对你的帐户采取限制措施，并限期要求您进行修改。</li>
          <li>
            您通过注册或者其他本公司允许的方式实际获得大众签章账号后，即可使用大众签章提供的电子签章的服务。
            <strong>
              <u>个人及企业注册成为大众签章用户后须进行实名认证，其中，根据实名认证方式的不同所需提供的实名认证资料将有所差异，具体所需资料请以本网站要求为准。个人需要提供的实名认证资料包括但不限于填写个人姓名，手机号码，身份证号码，提交身份证件图片，及手持身份证件图片等；企业需要提供的实名认证资料包括但不限于营业执照、统一社会信用代码、企业法定代表人姓名及其身份证信息，手机号码，电子邮箱等并且如果是经办人还需提供经办人身份信息及手机号及其他信息</u>
            </strong>。
          </li>
        </ul>
      </li>
    </ul>
    <p>
      <strong>&nbsp;</strong>
    </p>
    <ul>
      <li>
        账户安全
        <ul>
          <li>
            在您注册并取得本公司提供给您的账户后，您可以通过在计算机端、手机端以及使用其他电子设备登录大众签章平台。平台可以通过您的登录名及密码、短信校验码等方式来识别您的身份，并可以识别来自您使用的各类产品或设备的操作指令。您应当妥善保管您的大众签章登录名和密码、身份信息、手机验证码等信息，采取积极的保密措施，不得向其他任何人泄露。
            <strong>
              <u>对于因用户泄露登录名及密码、校验码以及身份信息或由于这些产品或设备遗失等所致的任何损失，由您自行承担。您确认，通过您的用户名和密码登录本网站及在本网站实施的一切行为，视为您本人的真实意图，您应当对大众签章依据上述指令所做执行的操作产生的结果承担责任</u>
            </strong>。
          </li>
          <li>
            <strong>
              <u>如您发现有他人冒用或盗用您的大众签章登录名、密码、验证码或任何其他未经合法授权之情形，或发生与大众签章账户关联的手机或其他设备遗失或其他可能危及到大众签章账户安全情形时，应立即以有效方式通知本公司，并申请账户锁定。</u>
            </strong>您理解本公司对您的请求采取行动需要合理期限，在此之前，本公司对已执行的指令及(或)所导致的您的损失不承担任何责任。
          </li>
          <li>
            您应确保在持续登录本平台时段结束时，以正确步骤离开网站。本公司不能也不会对因您未能遵守本款约定而发生的任何损失、损毁及其他不利后果负责。
            <strong>
              <u>您理解，本公司对您的请求采取行动需要合理期限，在此之前，本公司对已执行的指令及（或）所导致的您的损失不承担任何责任。</u>
            </strong>
          </li>
          <li>您确认，您应自行对您的大众签章账户负责，只有您本人方可使用该账户。该账户不可转让、不可赠与、不可继承。在您决定不再使用该账户时，您应将该账户内的可用数据导出或删除，并按本公司规定流程向本公司申请注销该账户。</li>
          <li>在您账号下关联的企业信息发生变更时，必须同步更新大众签章平台的相关企业信息及印章信息等信息。如您单位信息发生变更，大众签章平台相关信息未进行变更，那么您在大众签章平台操作产生的后果，大众签章平台将不负任何责任。</li>
          <li>在您决定不再使用该账户时，您应将该账户内的数据导出或删除，并按本公司规定流程向本公司申请锁定该账户。大众签章对因用户未能遵守本协议的约定而发生的任何直接或间接损失等不利后果不承担任何责任。</li>
          <li>
            如果本公司有合理理由怀疑用户提供虚假信息、进行欺诈等违法违规行为的，本公司有权根据相关国家法律法规的规定对用户个人信息以及签署的文件信息等进行核实、查询、披露，有权锁定相应账户并配合相关机关进行后续调查。
            <strong>
              <u>
                因国家
                法律法规、部门规章或监管机构的要求，本公司需要您补充提供任何相关资料时，如您不能及时配合提供，本公司有权暂停或终止向您提供部分或全部平台服务
              </u>
            </strong>。
          </li>
          <li>
            <strong>
              <u>
                本公司有权了解您使用本公司产品或服务的真实交易背景及目的，您应如实提供本公司所需的真实、全面、准确的信息。如果本公司有合理理由怀疑您提供虚假
                交易信息的，本公司有权暂时或永久限制您所使用的产品或服务的部分或全部功能
              </u>
            </strong>。
          </li>
        </ul>
      </li>
      <li>
        账户的锁定
        <ul>
          <li>
            用户登录大众签章账户，若密码连续
            <strong>5次</strong>输入错误，大众签章将临时锁定账户，持续时间为15分钟。在此期间，用户将无法使用大众签章的任何服务。
          </li>
          <li>用户在需要暂停本协议约定的服务时，可申请锁定大众签章账户。用户申请锁定的大众签章账户应当是依照本协议的约定注册并由大众签章提供给用户本人的账户，用户应当依照大众签章的规定程序申请账户锁定。</li>
          <li>用户申请锁定的大众签章账户应当处于正常状态，不存在任何可能由于该账户锁定而被影响的合同关系或其他权利义务关系，以及本公司认为锁定账户会由此产生未了结的权利义务而产生纠纷的情况。如申请锁定的账户有关联账户或子账户的，在该关联账户或子账户被锁定前，该账户不能申请锁定。.</li>
          <li>如果用户在使用本系统相关服务时有涉及违法违规行为的，大众签章有权锁定您名下的全部或部分账户。</li>
        </ul>
      </li>
      <li>
        账户的终止与注销
        <ul>
          <li>您所申请注销的大众签章账户应当是您本人依照《大众签章注册协议》的约定注册的账户。您应当依照本公司规定的程序或网站上的提示进行大众签章账户注销。</li>
          <li>
            在您注销大众签章账户后，本公司将终止为你提供相关服务，您与大众签章的协议关系终止（但依法或依照本协议其他条款不能终止的除外），
            <strong>
              <u>您将无法再使用该账户或找回您添加或绑定在该账户上的任何内容，包括数字证书、电子笔迹、电子印章、电子文件和签名记录相关信息，您应自行备份该账户相关的信息和数据</u>
            </strong>。操作之前，请确认与该账户相关的所有文档均已妥善处理。注销您的大众签章账户可能对该账户产生以下结果，由您自行承担：
            <ol>
              <li>注销账户后您名下的全部或部分登录账户、个人信息、交易信息及附属文档会不可被检索、访问；</li>
              <li>注销完成后，本公司无法对您之前留存下来的任何信息提供合同下载以及出证等服务；</li>
              <li>该账户所充值的套餐费用余额将不予退回；</li>
              <li>停止其他依据本协议约定的相关服务等</li>
            </ol>
          </li>
        </ul>
      </li>
    </ul>
    <p>&nbsp;</p>
    <ul>
      <li>出现以下情况时，大众签章有权直接以注销用户的方式终止本协议：</li>
    </ul>
    <ol>
      <li>您不是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织；</li>
      <li>您和大众签章的协议服务到期后未按照相关程序要求操作表明继续使用的；</li>
      <li>协议（含规则）变更时，您明示并通知大众签章不愿接受新的服务协议的；</li>
      <li>其它大众签章认为应当终止服务的情况。</li>
    </ol>
    <p>&nbsp;</p>
    <ul>
      <li>您确认在申请注销的大众签章账户时不存在任何由于该账户被注销而导致的未了结的合同关系与其他基于该账户的存在而产生或维持的权利义务，及本公司认为注销该账户会由此产生未了结的权利义务而产生纠纷的情况，并为此承担相应责任。</li>
      <li>您理解并同意大众签章可以依据相关监管要求在一定期限内保留您在使用大众签章服务期间提供或产生的信息，且在保存的时间内依法配合有权机关的查询。您在使用大众签章服务平台期间存在违法行为或违反本协议或规则的行为的，大众签章仍可依据本协议向您要求承担法律责任。</li>
    </ul>
    <ul>
      <li>
        通知与送达
        <ul>
          <li>本协议条款及任何其他的协议、公告或其他关于您使用本服务账号及服务的通知，您同意本网站使用电子方式通知您。电子方式包括但不限于以电子邮件方式、或于本网站或者合作网站上公布、或无线通讯装置通知等方式。</li>
          <li>
            <strong>
              <u>网站的通知如以公示方式做出，一经在本网站公示即视为已经送达。除此之外，其他向您个人发布的具有专属性的通知将由本网站在您注册时或者注册后变更用户信息时向本网站提供的电子邮箱或用户注册后在本网站绑定的手机号码发送，一经发送即视为已经送达。请您密切关注用户的电子邮箱以及手机中的短信信息。因信息传输或您变更邮箱但未在本网站的注册信息中填写您变更后的邮箱等原因导致您未在前述通知发出当日收到该等通知的，本网站不承担责任</u>
            </strong>。
          </li>
          <li>您同意大众签章利用在本网站登记的联系方式与您联络并向您传递相关的信息，包括但不限于行政管理方面的通知、产品信息、有关您使用本网站的通讯以及针对性的广告等。</li>
        </ul>
      </li>
    </ul>
    <p>&nbsp;</p>
    <ul>
      <li>
        使用规则及限制
        <ul>
          <li>
            使用规则
            <ul>
              <li>你同意接受本服务的相关规则。您了解并同意本公司有权单方修改服务的相关规则，而无须征得您的同意，服务规则应以您使用服务时的页面提示（或发送到该手机的短信或电话或客户端通知等）为准，您同意并遵照服务规则是您使用本服务的前提。</li>
              <li>
                本公司通过以下方式接受来自您的指令：A、您在本网站或其他可使用本服务的网站或软件上通过以您的大众签章账户名及密码或数字证书等安全产品登录大众签章账户并依照本服务预设流程所修改或确认的交易状态或指令；B、您通过您注册时作为该账户名称或者与该账户绑定的手机或其他专属于您的通讯工具号码向本公司发送的信息（短信或电话等）回复；C、您通过您注册时作为该账户名称或者与该账户名称绑定的其他硬件、终端、软件、代号、编码、代码、其他账户名等有形体或无形体向本公司发送的信息；
                <strong>
                  <u>D、本公司与您约定或本公司认可的其他方式。无论您通过以上四种方式中的任一种向本公司发出指令，都不可撤回或撤销，且成为本公司为您提供电子签名（签章）服务的唯一指令，视为您本人的指令，您应当自己对本公司忠实执行上述指令产生的任何结果承担责任</u>
                </strong>。本协议所称绑定，指您的大众签章账户与本条上述所称有形体或无形体存在对应的关联关系，这种关联关系使得大众签章服务的某些服务功能得以实现，且这种关联关系有时使得这些有形体或无形体能够作为本系统对您的大众签章账户的识别和认定依据。
              </li>
              <li>
                <strong>
                  <u>本公司会以电子邮件、发送手机短信等方式通知您电子签名（签章）等服务进展情况以及提示您进行下一步的操作，但本公司不保证您能够收到或者及时收到该邮件或短信等，且不对此承担任何后果，因此，在交易过程中您应当及时登录到本网站查看和进行电子签名（签章）操作</u>
                </strong>。因您没有及时查看交易状态和进行电子签名（签章）有关的其他操作而导致的任何纠纷或损失，本公司不负任何责任。
              </li>
              <li>您同意授权本公司向您的电子签署关联方定向提供您的签署信息并执行对应的操作，此授权不可撤销。且同意本服务在未改变您所提供信息实质内容的情况下免于承担因该信息引起的任何法律责任。您同意在您征得签署关联方同意的情况下，向本公司提供其必要的签署信息（包括但不限于姓名、联系电话、电子邮箱、身份证号码等），您对此信息的真实性负责，因您提供的信息不真实、不完整而导致的任何纠纷或损失，本公司不负任何责任。</li>
              <li>
                <strong>
                  <u>用户应在使用大众签章服务时，应审慎核查签署各方的身份信息，对于签署方中有未经大众签章实名认证的用户，可能产生签约主体不明或签约主体错误的风险，如需避免此风险，请各签署方进行实名认证并审慎核查签署方身份。否则，因此而产生的风险和责任，由用户自行承担</u>
                </strong>。您确认如您代表其他组织在本平台上签署文件的情况下，您向本公司提供其必要的签署信息（包括但不限于组织机构证明材料、印章等）已经获得该组织的合法授权，您应确保上述信息完整、真实、最新。您应对因您未能遵守本款约定而发生的任何损失、损毁及其他不利后果负责。
              </li>
              <li>您实际使用本公司提供的电子签章服务即视为您同意与您的签署相对方就电子文件的签署已经达成合意且同意使用电子签名的方式完成该文件的签署，并且您认可签署过程中产生的电子数据。</li>
              <li>
                用户在使用大众签章合同库时应根据自身的情况参考、修订使用本平台的公开或共享的合同、法律文书、条款等，大众签章平台不能对本网站中的公开文本（包括但不限于合同、法律文书、条款）的正确性进行保证。
                <strong>
                  <u>在任何情况下，用户（无论是付费或免费用户）不得因使用或依赖本网站上的信息、模板、文本而导致的任何损失要求大众签章承担责任，亦不得要求提供此信息的大众签章合作方承担责任</u>
                </strong>。公开文本来自于用户上传发布或网络公开渠道。如有涉嫌侵权（包括侵犯著作权、商业秘密或个人隐私等情形），欢迎用户向大众签章进行投诉，大众签章将视情况予以删除或修订处理。
              </li>
              <li>
                为了确保后期您的电子合同能更具有证明力，您授权大众签章平台收集固定您的签署信息，包括但不限于操作账号的设备信息、网络信息、系统日志、签署人身份信息、签署方式等数据。经您签署后的电子文件以及签署信息实时同步传输至大众签章的存证系统，并实时采用时间戳技术进行固定；经固定后的电子文件或签署信息，您可以通过大众签章平台出具电子版或纸质版本的证据报告，证明电子文件以及签署过程的真实性。
                <strong>
                  <u>大众签章提供的存证服务并不对您存证内容的真实性进行审查，仅对您存证的过程进行固定与证明。存证内容的真实性由您本人负责，涉及到您单方意思表示的，请慎重考虑。</u>
                </strong>
              </li>
              <li>除本协议另有规定外，如您与交易对方发生交易纠纷，您不可撤销地授权由本公司根据本协议及本网站上载明的各项规则进行处理，并同意将您的信息、数据传输至第三方机构（包括但不限于包括公证处、仲裁机构、鉴定机构、律师事务所等）。您为解决纠纷而支出的通讯费、文件复印费、鉴定费等均由您自行承担。但是大众签章对您所交易的协议内容本身不提供任何形式的鉴定、纠纷解决服务。因市场因素致使而使任何一方得益或者受到损失而产生的纠纷，本公司不予处理。用户可通过大众签章平台向符合中华人民共和国法律规定的相关单位寻求解决。</li>
              <li>
                本公司会将您的交易过程及产生的资料，严格按照法律法规或有权机关的监管要求进行管理；除本协议另有规定外，不作任何其他非您指示的用途。就您使用大众签章服务，本公司有权将您的身份信息及签约合同信息相应传输至电子认证服务机构（CA,
                Certificate
                Authority）或公证处，由CA以出具数字证书之目的或公证处以出具公证文件之目的使用并保存，且前述信息可以保存至数字证书失效后或相关电子数据（包括但不限于签约合同电子数据）产生后5年，并且该等信息不因您终止大众签章服务而停止保存。同时，本公司有权将您的身份信息、证件复印件或扫描件相应传输至征信机构及其他具有国家认可资质的数据服务提供商，由该等机构以验证签约方身份之目的使用并保存。您和任何签约方知悉并保证：本公司是数据电文等法律文件的签订平台，而不是CA机构或者实名认证机构。因此，您或者任何签约方通过本平台协助您和任何签约方开展实名认证的，本公司不对实名结果承担法律责任。因实名和意愿性校验无效而导致签订的数据电文等法律文件被认定无效的，相关的法律责任概与本公司无关。但因本公司故意造成无效的除外。您不得将本服务用于非本公司许可的其他用途。
              </li>
              <li>您授权并同意本公司将您通过不同方式登陆大众签章平台后的所有的电子数据进行信息同步，您可以登陆大众签章平台上的任一页面进行操作，该操作操作信息会同步在大众签章平台的其他的页面、APP或第三方应用的小程序中。</li>
            </ul>
          </li>
          <li>
            使用限制
            <ul>
              <li>您在使用本服务时应遵守中华人民共和国相关法律法规、您所在国家或地区之法令及相关国际惯例，不将本服务用于任何非法目的，也不以任何非法方式使用本服务。您不得利用本服务从事侵害他人合法权益之行为，否则本公司有权拒绝提供本服务，且您应承担所有相关法律责任，因此导致本公司或本公司雇员受损的，您应承担赔偿责任。</li>
              <li>
                您理解并同意，本公司不对因下述任一情况导致的任何损害赔偿承担责任，包括但不限于利润、商誉、使用、数据等方面的损失或其他无形损失的损害赔偿（无论本公司是否已被告知该等损害赔偿的可能性）：
                <ol>
                  <li>本公司有权基于单方判断，包含但不限于本公司认为您已经违反本协议的明文规定及精神，对您的名下的全部或部分大众签章账户暂停、中断或终止向您提供本服务或其任何部分，并移除您的资料。</li>
                  <li>
                    您理解并同意，存在如下情形时，本公司有权对您名下大众签章账户暂停或终止提供全部或部分大众签章服务，或对签名流程的全部或部分进行终止，且有权限制您所使用的产品或服务
                    <strong>
                      <u>的部分或全部功能</u>
                    </strong>
                    <u>（</u>包括但不限于对这些账户名下的电子文件和在途签名流程采取取消签名等限制措施），
                    并通过邮件或站内信或者客户端通知等方式通知您，您应及时予以关注：
                    <ul>
                      <li>根据本协议的约定；</li>
                      <li>根据法律法规及法律文书的规定；</li>
                      <li>根据有权机关的要求；</li>
                      <li>您使用大众签章服务的行为涉嫌违反国家法律法规及行政规定的；</li>
                      <li>本公司基于单方面合理判断认为账户操作、签名流程等存在异常时；</li>
                      <li>本公司依据自行合理判断认为可能产生风险的；</li>
                      <li>您在参加市场活动时有批量注册账户及其他舞弊等违反活动规则、违反诚实信用原则的；</li>
                      <li>您遭到他人投诉，且对方已经提供了一定证据的；</li>
                      <li>您可能错误地将他人账户进行了实名制或实名认证的。</li>
                    </ul>
                  </li>
                </ol>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    <p>
      <strong>&nbsp;</strong>
    </p>
    <ul>
      <li>如您申请恢复服务、解除上述止付或限制，您应按大众签章要求如实提供相关资料及您的身份证明以及大众签章要求的其他信息或文件，以便本公司进行核实，且大众签章有权依照自行判断来决定是否同意您的申请。您应充分理解您的申请并不必然被允许。您拒绝如实提供相关资料及身份证明的，或未通过大众签章审核的，则您确认大众签章有权长期对该等账户停止提供服务且长期限制该等产品或者服务的部分或全部功能。</li>
      <li>
        在本公司认为该等异常已经得到合理解释或有效证据支持或未违反国家相关法律法规及部门规章的情况下，最晚将于得到解释之日起
        <strong>30</strong>个工作日内解除限制。但本公司有进一步理由相信该等异常仍可能对您或其他用户或本公司造成损失的情形除外。
      </li>
      <li>在使用大众签章的过程中，用户发现任何可能侵害自己或大众签章权利的事实时，应及时通知大众签章并提供相应的证明材料。因投诉不实给大众签章或第三方造成损失的，用户应承担法律责任。大众签章有权接受并处理您与其他用户间因使用大众签章服务而产生的纠纷及投诉，有权通过电话、短信、电子邮件等联系方式向您了解情况，并将所了解的情况通过上述方式通知对方。您有义务在收到大众签章通知后，在指定的时间内提供相应的资料，以配合纠纷及投诉的情况了解与处理，否则，大众签章有权单方面独立判断其他用户对您的投诉，一旦成立，并做出对您不利的处理结果。同时，大众签章有权立即中止或终止您的相关大众签章服务。大众签章受理、处理纠纷、争议及投诉完全依据您的授权。因大众签章对证据的鉴别能力及对纠纷的处理能力有限，不保证处理结果一定符合您的期望。大众签章有权决定是否参与争议的处理。</li>
      <li>
        <strong>
          <u>请注意：根据《电子签名法》的规定下列情形不适合使用电子文书：涉及婚姻、收养、继承等人身关系的；涉及停止供水、供热、供气等公用事业服务的；法律、行政法规规定的不适用电子文书的其他情形。因此，用户不得在大众签章平台上签订上述法律文件。若用户在大众签章平台上传并签订上述法律文件，而根据法律之规定上述签约行为无效的，大众签章不承担任何责任</u>
        </strong>。
      </li>
      <li>您不得将本服务用于非本公司许可的其他用途。</li>
    </ul>
    <p>&nbsp;</p>
    <ul>
      <li>用户隐私政策</li>
    </ul>
    <p>请您详见《大众签章隐私政策》</p>
    <ul>
      <li>
        知识产权声明
        <ul>
          <li>
            本网站上所有内容，包括但不限于著作、图片、档案、资讯、资料、网站架构、网站画面的安排、网页设计、软件、技术均由本公司或本公司关联企业依法拥有其知识产权，包括但不限于商标权
            、专利权、著作权、商业秘密等。
          </li>
          <li>非经本公司或本公司关联企业书面同意，任何人不得擅自使用、修改、复制、公开传播、改变、散布、发行或公开发表本网站程序或内容。</li>
        </ul>
      </li>
      <li>
        免责声明
        <ul>
          <li>
            本公司系统因下列状况无法正常运作，使您无法使用各项服务时，本公司不承担损害赔偿责任，该状况包括但不限于：本公司在本网站公告之系统停机维护期间；电信设备出现故障不能进行数据传输的；
            因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素，造成本公司系统障碍不能执行业务的；由于黑客攻击、电信部门技术调整或故障、网站升级等原因而造成的服务中断或者延迟。本公司仅对本协议中列明的责任承担范围负责。
          </li>
          <li>
            您在使用大众签章平台提供的相关服务时应遵守中国有关法律、法规、规章以及政府规范性文件，并遵守所有与使用大众签章平台有关的协议、规定、程序和惯例，也
            <strong>
              <u>不得利用大众签章平台进行任何非法或违规活动（上述行为包括但不限于：从事不法交易行为，虚假交易行为，侵害他人合法权益或盗用冒用他人账号，任何害本服务系统，资料之行为或本公司有正当理由认为不适当之行为等）。由此导致本公司或本公司雇员或其他方受损的，您应承担赔偿责任</u>
            </strong>。
          </li>
          <li>当您和数据电文的签约方在签订数据电文等法律文件时，应当自行判定自己及其他当事人的主体资格是否适格。如果您和/或者其他当事人是无民事行为能力人或者限制民事行为能力人，不得签订或者仅能签订与自己的年龄、智力和精神健康状况相适应的法律文件。因主体不适格导致通过大众签章平台签订的数据电文等法律文件无效的，责任和法律后果由您和该法律文件其他签约方自己承担。大众签章对您签署的协议内容不承担任何责任；大众签章对您因执行协议所产生的纠纷，不承担解决义务，您可依据法律规定寻求相关途径及单位解决。</li>
          <li>
            <strong>
              <u>用户需对其在大众签章平台上的所有行为及注册时向本公司提供的任何形式的材料、信息（内容包括但不限于个人信息、商业信息，形式包括但不限于文字、图片）的合法性、真实性、准确性、完整性以及由此产生的所有问题独立承担一切责任。</u>
            </strong>同时，在您所发布的信息中不得含有蓄意毁坏、恶意干扰、秘密地截取或侵占任何系统、数据或个人资料的任何病毒、伪装破坏程序、电脑蠕虫、定时程序炸弹或其他电脑程序。用户如因违反本协议规定的义务给本公司造成损失，必须负责相应赔偿。
          </li>
          <li>
            因交易所产生的任何风险应由您与交易对方承担。在法律允许的情况下，本公司对于与本协议有关或由本协议引起的任何间接的、惩罚性的、特殊的、派生的损失（包括业务损失、收益损失、利润损失、商誉损失、使用数据
            或其他经济利益的损失），不论是如何产生的，也不论是由对本协议的违约（包括违反保证）还是由侵权造成的，均不负有任何责任，即使事先已被告知此等损失的可能性。另外即使本协议规定的排他性救济没有达到其基本目的，也应排除本公司对上述损失的责任。
          </li>
          <li>
            <strong>
              <u>您充分知晓并同意本公司可能同时为您及您的对手方提供本服务，您同意对本公司可能存在的该等行为予以明确豁免，并不得以此来主张本公司在提供本服务时存在法律上的瑕疵。</u>
            </strong>
          </li>
          <li>除本协议另有规定或本公司另行同意外，您对本公司的委托及向本公司发出的指令均不可撤销。</li>
          <li>本网站内容可能涉及由第三方所有、控制或运营的其它网站（以下称&ldquo;第三方网站&rdquo;）。本网站不能保证也没有义务保证第三方网站上的信息的真实性和有效性。您应按照第三方网站的相关协议与规则使用第三方网站，而不是按照本协议。第三方网站的内容、产品、广告和其他任何信息均由您自行判断并承担风险，而与本网站无关。</li>
          <li>在使用本服务时，若您或您的签约对方未遵从本服务条款或网站说明、交易页面中之操作提示、规则），则本公司有权拒绝为您与签约对方提供相关服务，且本公司不承担损害赔偿责任。因用户的过错导致的任何损失由用户自行承担，该过错包括但不限于：不按照电子签名（签章）提示操作、未及时进行实名认证操作、未及时进行电子签名（签章）操作、遗忘或泄漏密码、用户委托他人代理签署时他人恶意或不当操作而造成的损失、密码被他人破解、您使用的计算机被他人侵入。</li>
        </ul>
      </li>
      <li>
        违约责任
        <ul>
          <li>
            因您违反本协议或经在此提及而纳入本协议的其他文件，或因您违反了法律、法规、规章、政府规范性文件或侵害了第三方的权利，而使第三方对大众签章及其股东、职员、代理人提出索赔要求（包括司法费用和其他专业人士的费用），您必须对大众签章及股东
            、职员、代理人承担赔偿责任，使其等免遭损失。
          </li>
          <li>
            <strong>
              <u>除本协议另有规定外，在任何情况下，本公司对本协议所承担的违约赔偿责任总额不超过向您收取的当次服务费用总额。</u>
            </strong>
          </li>
        </ul>
      </li>
    </ul>
    <p>&nbsp;</p>
    <ul>
      <li>
        争议解决
        <ul>
          <li>本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律，没有相关法律规定的，参照通用国际商业惯例和（或）行业惯例。如因本协议或大众签章服务所引起或与其有关的任何争议应向山东国盾网信息科技有限公司所在地人民法院起诉。</li>
        </ul>
      </li>
      <li>
        其他
        <ul>
          <li>您使用大众签章相关服务时，亦应充分阅读、认可并同意遵守相关服务的额外条款。</li>
          <li>本协议自您同意勾选并成功注册为本网站用户之日起生效，除非本网站终止本服务协议或者用户丧失本网站用户资格，否则本服务协议始终有效。本服务协议终止并不免除用户根据本服务协议或其他有关协议、规则所应承担的义务和责任。</li>
          <li>本服务协议部分条款被认定为无效时，不影响本服务协议其他条款的效力。</li>
          <li>本协议中的标题仅为方便而设，在解释本协议时应被忽略。</li>
          <li>大众签章对本服务协议享有最终的解释权。</li>
        </ul>
      </li>
    </ul>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>
      <strong>大众签章数字证书服务协议</strong>
    </p>
    <p>
      <strong>声明：</strong>
    </p>
    <ol>
      <li>您应当认真阅读并遵守《数字证书服务协议》（以下简称&ldquo;本协议&rdquo;），本协议具有合同效力，当您勾选确认并完成全部注册程序后即成立生效。</li>
      <li>请您务必审慎阅读、充分理解各条款内容，特别是大众签章权利条款、免责条款和争议解决条款。如您对本协议有任何疑问或对任何条款不能准确理解的，请不要进行后续操作。</li>
      <li>您承诺接受并遵守本协议的约定，届时您不可以未阅读本协议内容或未获得山东国盾网信息科技有限公司对您问询的解答等理由，主张本协议无效，或要求撤销本协议。</li>
      <li>
        本数字证书服务协议更新日期为
        <strong>2021年1月28日，将于2021年1月28日正式生效。</strong>
      </li>
    </ol>
    <p>一、数字证书服务简介</p>
    <ol>
      <li>山东国盾网信息科技有限公司与信息产业部认可的电子认证中心合作，为通过实名认证后的互联网个人或企业颁发数字证书，为互联网个人或企业提供全面的电子签名服务。</li>
      <li>您通过山东国盾网信息科技有限公司的大众签章平台完成实名认证并使用数字证书获得电子签名信任服务，成为大众签章电子签名体系不可分割的部分。</li>
      <li>本协议中的&ldquo;证书&rdquo;指个人证书或企业证书。</li>
      <li>该证书的形式包含UKEY证书。</li>
    </ol>
    <p>二、名词解释</p>
    <ol>
      <li>订户：</li>
    </ol>
    <p>指从委托大众签章从权威第三方数字认证中心获得证书的个人、组织机构。</p>
    <ol start="2">
      <li>数字证书：</li>
    </ol>
    <p>是指一段信息，它至少包含了一个名字，标识特定的CA或标识特定的订户，包含了订户的公钥、证书有效期、证书序列号，及CA数字签名。</p>
    <ol start="3">
      <li>证书私钥：</li>
    </ol>
    <p>数字证书包含证书本身和一个密钥对，密钥对的一部分是公钥，另一部分称为私钥。公钥公之于众，谁都可以使用。私钥只有自己知道，一般信息都是由公钥进行加密，相对应的私钥进行解密。</p>
    <p>&nbsp;</p>
    <p>三、订户的权利和义务</p>
    <ol>
      <li>您应按照大众签章规定的证书申请流程向大众签章平台提供有关资料，并保证所填写的注册信息和所提供的资料的真实性、准确性和完整性，否则大众签章平台有权拒绝您的申请请求。</li>
      <li>您的证书信息在证书有效期限内变更的，应当及时书面告知大众签章平台，并终止使用该证书。</li>
      <li>若您为企业用户，您企业分立、合并、解散、注销、宣告破产或倒闭，或被撤销营业执照等主体资格终止的，应于上述情况发生时的5个工作日内通过书面形式告知大众签章申请撤销数字证书，并终止使用该证书，否则，因未尽该通知义务给大众签章造成损失的，由您全部赔偿。</li>
      <li>您同意大众签章平台向有关部门和个人核实您的信息。大众签章平台应合法地收集、处理、传递及应用您的资料，按照国家有关规定及本协议的约定予以保密。</li>
      <li>您对证书享有独立的使用权。您使用证书产生的权利，由您享有；您使用证书产生的义务、责任，由您承担。</li>
      <li>您应当妥善保管证书私钥。因您原因致使证书私钥泄露、损毁或者丢失的，损失由您承担。</li>
    </ol>
    <p>四、证书的使用、更新、吊销</p>
    <ol>
      <li>本证书只能在有效期限内、在大众签章平台上使用。证书有效期限届满，大众签章将为您自动更新证书。</li>
      <li>本协议的有效期限为证书的有效期限。证书期限届满，证书更新的，本协议有效期限顺延至证书更新期限届满日。</li>
      <li>证书私钥在证书有效期内损毁、丢失、泄露的，您应当及时申请办理吊销手续，吊销自手续办妥时起生效，吊销生效前发生的损失由您承担。</li>
      <li>您知悉证书私钥已经丢失或者可能已经丢失时，应当及时告知大众签章平台，协助完成吊销该证书的工作，并终止使用该证书。</li>
    </ol>
    <p>五、大众签章的权利</p>
    <p>您有下列情形之一，大众签章有权向第三方机构申请吊销证书并不承担任何责任。由此给大众签章造成损失的，您应当向大众签章承担赔偿责任：</p>
    <ol>
      <li>您向大众签章平台提供的资料或者信息不真实、不完整或者不准确的。</li>
      <li>您证书的信息有变更，未终止使用该证书并通知大众签章平台的。</li>
      <li>您知悉证书私钥已经丢失或者可能已经丢失时，未终止使用该证书并通知大众签章平台的。</li>
      <li>您超过证书的有效期限及应用范围使用证书的。</li>
      <li>您企业分立、合并、解散、注销、宣告破产或倒闭，被撤销营业执照等主体资格终止的。</li>
      <li>您使用证书用于违法、犯罪活动的。</li>
    </ol>
    <p>7、其他以您使用证书对大众签章造成损失的情况。</p>
    <p>六、免责条款</p>
    <ol>
      <li>因设备故障、电力故障及通讯故障或者电脑病毒、自然灾害等因素造成您损失的，大众签章不承担任何责任。</li>
      <li>由于第三方电子认证中心的原因导致证书私钥被破译、窃取，致使您遭受损失的，由第三方电子认证中心向您承担赔偿责任。</li>
    </ol>
    <p>七、协议的终止</p>
    <p>有下列情形之一的，本协议终止：</p>
    <ol>
      <li>您证书期限届满。</li>
      <li>您证书被吊销。</li>
      <li>您向大众签章申请终止本协议，大众签章同意的。</li>
      <li>双方协商终止本协议的。</li>
      <li>依据法律、法规等规定，本协议应当终止的。</li>
    </ol>
    <p>八、争议解决条款</p>
    <p>因本协议产生的争议，不论争议金额大小，均提交山东国盾网信息科技有限公司所在地经济仲裁委员会仲裁规则项下的简易程序进行仲裁。仲裁裁决为终局的，对各方均有拘束力。</p>
    <p>
      <strong>&nbsp;</strong>
    </p>
    <div class="backbtn" v-if="$route.query.type">
      <van-button type="info" @click="$router.go(-1)">返回</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'userProtocol',
  data() {
    return {
      screenWidth: '',
      screenHeight: ''
    }
  },
  mounted() {
    // var w = window.screen.width
    // this.screenWidth = document.body.clientWidth
    // this.screenHeight = document.body.clientHeight
    // window.onresize = () => {
    //   return (() => {
    //     this.screenWidth = document.body.clientWidth
    //     this.screenHeight = document.body.clientHeight
    //     var d = document.getElementById('userProtocol')
    //     d.style.width = this.screenWidth + 'px'
    //     d.style.height = this.screenHeight + 'px'
    //   })()
    // }
  }
}
</script>

<style scoped lang="scss">
.user-doc {
  width: 100%;
  overflow: hidden;

  text-align: left;
  strong {
    font-weight: bold;
  }
  .backbtn {
    position: fixed;
    bottom: 0;
    width: 100%;
    background-color: white;
    text-align: center;
    button {
      width: 100%;
    }
  }
}
</style>